import React from "react";
import { View, Image, Text, useWindowDimensions } from "react-native";
import { AppImages } from "../../../../utility/AppImages";
import { DEVICE_SIZES } from "rn-responsive-styles";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppColors } from "../../../../utility/AppColors";
import SvgImage from "../../../../Components/choose-avatar-components/SvgImage";

export const ImWatchingPosterImage = ({ deviceSize, item }) => {
  const { width: screenWidth } = useWindowDimensions();

  const containerWidth =
    deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
      ? 122
      : Math.min(350, screenWidth - 40);

  const containerHeight =
    deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS ? 33 : 100;

  const avatarSize = containerWidth * 0.26;
  const gameImageWidth = containerWidth * 0.35;
  const gameImageHeight = containerHeight * 0.75;
  const vsSize = containerWidth * 0.09;

  return (
    <View style={{ alignItems: "center" }}>
      <View
        style={{
          position: "relative",
          width: containerWidth,
          height: containerHeight,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Image
          source={AppImages.icCardBg}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            resizeMode: "cover",
            borderTopRightRadius: 16,
            borderTopLeftRadius: 16,
          }}
        />

        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            paddingHorizontal: 8,
          }}
        >
          {/* First Player */}
          <View style={{ alignItems: "center" }}>
            <Image
              source={{
                uri:
                  item?.details?.participantProfiles[0]?.profilePicture ||
                  "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg",
              }}
              style={{
                width: avatarSize,
                height: avatarSize,
                resizeMode: "contain",
                transform: [{ rotateY: "180deg" }],
              }}
            />
            <View
              style={{
                position: "absolute",
                paddingHorizontal: 4,
                paddingVertical: 2,
                borderRadius: 7,
                backgroundColor: "#655AFF80",
                opacity: 0.7,
                bottom: -12,
                left: 0,
              }}
            >
              <Text
                style={
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? AppFontStyle.BOLD_ANYBODY_6
                    : AppFontStyle.BOLD_ANYBODY_14
                }
              >
                {item?.details?.participantProfiles[0]?.userId}
              </Text>
            </View>
          </View>

          {/* Center Game Image */}
          <View style={{ position: "relative" }}>
            <Image
              source={{
                uri: item?.details?.gameImage || AppImages.icFreeFireGame,
              }}
              style={{
                width: gameImageWidth,
                height: gameImageHeight,
                borderRadius: 8,
                resizeMode: "contain",
              }}
            />

            {/* VS icon */}
            <View
              style={{
                position: "absolute",
                top: 0,
                left: "50%",
                transform: [
                  { translateX: -vsSize / 2 },
                  { translateY: -vsSize / 2 },
                ],
                backgroundColor: AppColors.white,
                borderRadius: vsSize / 2,
                width: vsSize,
                height: vsSize,
                justifyContent: "center",
                alignItems: "center",
                opacity: 0.7,
              }}
            >
              <SvgImage src={AppImages.icVsLogo} variant="notificationVs" />
            </View>
          </View>

          {/* Second Player */}
          <View style={{ alignItems: "center" }}>
            <Image
              source={{
                uri:
                  item?.details?.participantProfiles[1]?.profilePicture ||
                  "https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg",
              }}
              style={{
                width: avatarSize,
                height: avatarSize,
                resizeMode: "contain",
              }}
            />
            <View
              style={{
                position: "absolute",
                paddingHorizontal: 4,
                paddingVertical: 2,
                borderRadius: 7,
                backgroundColor: "#655AFF80",
                opacity: 0.7,
                bottom: -12,
                right: 0,
              }}
            >
              <Text
                style={
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? AppFontStyle.BOLD_ANYBODY_6
                    : AppFontStyle.BOLD_ANYBODY_14
                }
              >
                {item?.details?.participantProfiles[1]?.userId}
              </Text>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};
